'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _notBefore = require('./not-before');
var _notBefore2 = _interopRequireDefault(_notBefore);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'The date cannot be in the past';
  var extraOptions = arguments[1];
  return (0, _notBefore2.default)(new Date(), errorMessage, extraOptions);
};